import { SvgAllstarLettermark } from "@ugitgud/legos/ui/icon/SVG/AllstarLettermark";
import { SvgMiscSearch } from "@ugitgud/legos/ui/icon/SVG/MiscSearch";
import { AllstarEmbed } from "@ugitgud/legos/components/home-page/AllstarEmbed";
import { SvgAllstarLogo } from "@ugitgud/legos/ui/icon/SVG/AllstarLogo";
import { AllstarLogoPurpleIcon } from "@ugitgud/legos/ui/icon/raster/shared";

export function FeaturedPartnerProduct() {
  return (
    <div className="flex items-center flex-row flex-nowrap gap-3 justify-between mt-16 sm:mt-[180px] max-w-[1016px] w-full mx-auto px-3 lg:px-0">
      <div className="flex flex-col">
        <p className="text-[24px] font-bold mb-6 text-white">Featured Partner Product</p>
        <div className="flex items-center flex-row flex-nowrap text-[36px] font-bold gap-3 mb-3 text-white">
          <div className="flex items-center justify-center bg-[#191937] rounded-[3px] h-[26px] w-[26px] min-w-[26px]">
            <AllstarLogoPurpleIcon className="w-[18px] min-w-[18px]" />
          </div>
          <SvgAllstarLogo className="w-auto h-[26px]" />
        </div>
        <p className="text-[#cddcfe] text-[18px] font-normal mb-9 mt-2 max-w-[300px]">
          Fast, free 1080P60 clips, from any League of Legends match. Zero FPS hit, magically out of thin air.
        </p>
        <div className="flex flex-row flex-nowrap gap-3 text-[13px] font-bold mb-[18px]">
          <a href="https://allstar.gg/match-history?utm_source=U.GG&utm_medium=site&utm_content=homepage" target="_blank">
            <div className="cursor-pointer flex items-center justify-center flex-row flex-nowrap gap-2 rounded-[3px] h-9 w-[150px] bg-[#3273fa] hover:bg-[#2963da] text-white transition-colors duration-150 ease-in-out">
              <SvgMiscSearch className="w-[18px] min-w-[18px]" /> Find Matches
            </div>
          </a>
          <a href="https://allstar.gg/start?utm_source=U.GG&utm_medium=site&utm_content=homepage" target="_blank">
            <div className="cursor-pointer flex items-center justify-center flex-row flex-nowrap gap-2 rounded-[3px] h-9 w-[150px] bg-lavender-500 hover:bg-lavender-600  text-white transition-colors duration-150 ease-in-out">
              How it Works
            </div>
          </a>
        </div>
        <div className="flex items-center flex-row flex-nowrap gap-3 text-xs font-normal text-[#5c5c8e]">
          <SvgAllstarLettermark className="w-[12px] h-[12px]" />
          Captured in the cloud by Allstar.gg
        </div>
      </div>
      <AllstarEmbed path={"league/clips/playlist?isProPlayer=true&ifOnly=isProPlayer&sort=score&age=1d&limit=10"} />
    </div>
  );
}
